<template>
	<div>
		<Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
			<template>
				<div v-if="open" class="overflow-auto h-full">
          <div class="flex">
            <div class="m-1 mr-10">
              <PrimaryButton
                text="物件概要書"
                class="bg-yellow-700"
                :buttonContents="'要'"
                :disabled="loading"
                @click="toSiteOutline">
              </PrimaryButton>
            </div>
            <!-- キャンセル -->
            <div v-if="!outOfGps" class="w-fit ml-auto m-1">
              <PrimaryButton
                text="キャンセル"
                class="bg-blue-50 text-blue-700 border-blue-700"
                :buttonContents="'要'"
                :disabled="loading"
                @click="closed">
              </PrimaryButton>
            </div>
          </div>

          <!-- 物件名 -->
          <div class="text-lg text-gray-700 font-bold mt-3">
            {{ target.site }}
          </div>

          <!-- 住所 -->
          <div class="mt-3 text-xs text-gray-500 font-bold mb-1">物件 住所</div>
          <div class="text-sm">{{ target.address || '*住所なし*' }}</div>

          <!-- GPSが範囲外 -->
          <div v-if="outOfGps" class="mt-3">
            <div v-if="target.address" class="text-red-700 font-bold">対象物件から離れています。物件の住所を確認後、どれか1つを選択してください。</div>
            <div v-else class="text-red-700 font-bold">対象物件の住所が登録されていません。「完了にする・物件の住所が違う」を押してください。</div>
            <div class="my-5 mx-2 whitespace-nowrap text-center">
              <PrimaryButton
                text="キャンセル"
                class="bg-blue-50 text-blue-700 border-blue-700 w-full"
                :buttonContents="'要'"
                :disabled="loading"
                @click="outOfGps=false">
              </PrimaryButton>
            </div>
            <div class="my-5 mx-2 whitespace-nowrap text-center">
              <PrimaryButton
                text="完了にする・物件の住所が違う"
                class="bg-yellow-700 w-full"
                :buttonContents="'要'"
                :disabled="loading"
                @click="save(2)">
              </PrimaryButton>
            </div>
            <div class="my-5 mx-2 whitespace-nowrap text-center">
              <PrimaryButton
                text="完了にする・自分の位置が違う"
                class="bg-teal-700 w-full"
                :buttonContents="'要'"
                :disabled="loading"
                @click="save(3)">
              </PrimaryButton>
            </div>
            <!-- <div class="my-5 mx-2 whitespace-nowrap text-center">
              <PrimaryButton
                text="完了にする・押し忘れ"
                class="bg-pink-700 w-full"
                :buttonContents="'要'"
                :disabled="loading"
                @click="save(4)">
              </PrimaryButton>
            </div> -->
          </div>

          <!-- ボタン押す前 -->
          <div v-else>
            <div class="mt-3">
              <!-- ゴミ出し予定ありの場合 -->
              <div v-if="target.isTrash" class="my-5 mx-2 whitespace-nowrap text-center">
                <!-- スタッフ名 -->
                <div class="text-green-700">
                  <span v-if="!target.trashDoneTime">担当:</span>
                  <span v-else>実施:</span>
                  {{ target.trashStaff }}
                </div>
                <!-- ゴミ出し未完了 -->
                <div v-if="!target.trashDoneTime">
                  <PrimaryButton
                    text="ゴミ出し完了"
                    class="bg-green-700 w-full"
                    :buttonContents="'要'"
                    :disabled="loading"
                    @click="doneBtn('trash')">
                    <LoadingIcon v-if="loading" slot="before" class="h-5 w-5 mr-1" />
                  </PrimaryButton>
                </div>
                <!-- ゴミ出し完了済み -->
                <div v-else>
                  <PrimaryButton
                    text="ゴミ出し完了済み"
                    class="bg-green-50 text-green-700 border-green-700 w-full"
                    :buttonContents="'要'"
                    :disabled="loading">
                  </PrimaryButton>
                </div>
              </div>

              <!-- 清掃予定ありの場合 -->
              <div v-if="target.isClean" class="my-5 mx-2 whitespace-nowrap text-center">
                <!-- スタッフ名 -->
                <div class="text-purple-700">
                  <span v-if="!target.cleanDoneTime">担当:</span>
                  <span v-else>実施:</span>
                  {{ target.cleanStaff }}
                </div>

                <!-- ゴミ出しあり・ゴミ未完了 -->
                <div v-if="target.isTrash&&!target.trashDoneTime">
                  <div class="whitespace-nowrap text-xs font-bold">「ゴミ完了後」に清掃完了できます</div>
                </div>

                <!-- 7:30以前 -->
                <div v-else-if="!checkTime()">
                  <div class="whitespace-nowrap text-xs font-bold">
                    <p>「7:30以降」に清掃完了できます</p>
                    <p>7:30以降に再度この画面を開いてください</p>
                  </div>
                </div>

                <!-- 7:30以降 -->
                <div v-else>
                  <!-- 報告書作成 -->
                  <div>
                    <p v-if="target.isReport" class="text-sm text-red-700 font-bold mt-1">報告書が必要な物件です</p>
                    <p v-if="target.isReport&&(target.mc||target.sc)" class="text-sm text-red-700 font-bold my-1">（今月 通常 {{ target.mc || 0 }}回{{ target.sc ? '、特別仕様 ' + target.sc + '回' : '' }} 報告書作成済み）</p>
                    <PrimaryButton
                      v-if="target.isReport||target.report"
                      :text="target.report?'報告書作成済み':'報告書作成'"
                      class="bg-purple-800 w-full block mb-3"
                      :buttonContents="'要'"
                      :disabled="loading"
                      @click="toReport()">
                      <LoadingIcon v-if="loading" slot="before" class="h-5 w-5 mr-1" />
                    </PrimaryButton>
                  </div>

                  <!-- 清掃完了 -->
                  <div v-if="!target.cleanDoneTime">
                    <PrimaryButton
                      text="清掃完了"
                      class="bg-purple-700 w-full block"
                      :buttonContents="'要'"
                      :disabled="loading"
                      @click="doneBtn('clean')">
                      <LoadingIcon v-if="loading" slot="before" class="h-5 w-5 mr-1" />
                    </PrimaryButton>
                  </div>
                  <!-- 清掃完了済み -->
                  <div v-else>
                    <PrimaryButton
                      text="清掃完了済み"
                      class="bg-purple-50 text-purple-700 border-purple-700 w-full"
                      :buttonContents="'要'"
                      :disabled="loading">
                    </PrimaryButton>
                  </div>
                </div>
                <!-- 振替情報 -->
                <div v-if="target.exchange" class="text-xs text-purple-700 mt-2">{{ target.exchange }}の振替</div>
              </div>
            </div>

          </div>
				</div>
			</template>
		</Modal>
	</div>
</template>
<script>

import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import BigNumber from "bignumber.js"
import LoadingIcon from '@assets/loading-circle.svg'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as moment from 'moment'

export default {
	components: {
		Modal,
    PrimaryButton,
    LoadingIcon
	},

	props: {
    // 対象物件
		target: {
			type: Object
		},
		open: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
      loading: false,
      // 位置情報が範囲外
      outOfGps: false,
      // 完了した種別 trash / clean
      type: null,
      // GPS問題ありの実施者の位置情報
      latLng: {}
		}
	},

	watch: {
		open() {
			if (!this.open) {
				return
			}
		}
	},

  computed: {
    staffId() {
      return this.$store.getters.user.id
    },
    staff() {
      return utils.deleteKana(this.$store.getters.user.user_name)
    }
  },

	methods: {
		/**
		 * 初期化
		 */
		closed(isNotUpdate) {
			this.loading = false
      this.outOfGps = false
      this.type = ''
      this.latLng = {}
      this.$emit('closed', isNotUpdate)
		},

    /**
     * 完了ボタン
     * @param type 種別
     */
    async doneBtn(type) {
      this.loading = true
      this.type = type
      // 現状況
      let result = null
      // GPS状況（0：取得不可、1：問題なし・範囲内、2：物件住所が違う、3：GPSが変）
      let gps = null
      // 誤差教養範囲
      const gpsDiff = 0.003

      // 完了されていないか確認のため、データ取得
      const res = await backend.searchData('rls/getResultBysiteDay', { siteCode: this.target.siteCode })
      if (res.data.data && res.data.data.length) {
        result = res.data.data[0]
      }
      if (result && result[type + 'DoneTime']) {
        this.loading = false
        await dialogs.showErrorDialog('すでに完了済み', 'すでに完了しています。MAPを更新します。')
        this.$emit('refreshMap')
        this.closed()
        return
      }

      // 現在地取得
      const current = await utils.getLocation2()

      // GPS取得不可
      if (current.err || !current.lat || !current.lng) {
        this.loading = false
        alert('GPS取得不可になっています。iphoneのGPS設定をご確認ください。')
        return

      // GPS取得
      } else {
        // 物件位置と現在地比較
        const diff1 = Math.abs(BigNumber(this.target.lat).minus(current.lat))
        const diff2 = Math.abs(BigNumber(this.target.lng).minus(current.lng))

        // 緯度経度が許容範囲の場合
        if (diff1 <= gpsDiff && diff2 <= gpsDiff) {
          gps = 1

        // 緯度経度が許容範囲外
        } else {
          // 再度、物件の緯度経度を取得する
          const retry = await this.getSiteLatLng(current, gpsDiff)
          if (retry) {
            gps = 1
          } else {
            this.latLng = current
            this.outOfGps = true
            this.loading = false
            return
          }
        }
      }

      await this.save(gps)
    },

    /**
     * 再度物件の緯度経度を取得
     */
    async getSiteLatLng(current, gpsDiff) {
      const res = await backend.searchData('patrolSchedule/updatePosition', { address: this.target.address, siteCode: this.target.siteCode })
      if (res.data.data && res.data.data.lat) {
        // 物件位置と現在地比較
        const diff1 = Math.abs(BigNumber(res.data.data.lat).minus(current.lat))
        const diff2 = Math.abs(BigNumber(res.data.data.lng).minus(current.lng))
        if (diff1 <= gpsDiff && diff2 <= gpsDiff) {
          return true
        }
      }
      return false
    },

    /**
     * 7:30以前は清掃完了NG
     */
    checkTime() {
      const time = Number(moment().format('HHmm'))
      if (time < 730) {
        return false
      }
      return true
    },

    /**
     * 保存
     * @param gps GPS状況（0：取得不可、1：問題なし・範囲内、2：物件住所が違う、3：GPSが変、4：押し忘れ）
     */
    async save(gps) {
      const saveData = {
        ...this.target,
        type: this.type,
        staffId: this.staffId,
        staff: this.staff,
        gps,
        current: this.latLng,
        userDepartment: this.$store.getters.userDepartment
      }

      this.loading = true
      if (gps == 2) {
        // メインタスク登録
        let msg = ''
        // console.log('情報')
        // console.log(this.target)
        if (this.target.trashDoneTime || this.target.cleanDoneTime) {
          msg = '（本日2回目の可能性あり）'
        }
        utils.mainForRlsSiteAddress(saveData, this, msg)
      }
      try {
        await backend.postData('rls/saveResult', saveData)
        this.closed()
      } catch (error) {
        this.loading = false
        alert('保存できませんでした。申し訳ございませんが再度お願いいたします。')
      }
    },

    /**
     * 報告書作成へ
     */
    async toReport() {
      this.loading = true
      // すでに作られていないか確認＆作られていない場合は予定を生成
      const param = {
        siteCode: this.target.siteCode,
        siteName: this.target.site,
        siteAddress: this.target.address,
        staffId: this.staffId,
        staff: this.staff,
        type: 2
      }
      const res = await backend.postData('patrolSchedule/saveFromRls', param)

      this.closed(true)
      // 清掃担当予定
      const cleanStaffId = this.target.cleanStaffId
      // ゴミ出し予定
      const isTrash = this.target.isTrash
      // 報告書画面に遷移
      if (res.data.data) {
        // paramにスケジュールIDを渡す
        let scheduleId = res.data.data
        // 点検表に遷移
        this.$router.push({
          name: 'RoundCheckListTable',
          query: { scheduleId, claim: false, sub: 0, rls: true },
          params: { scheduledDate: moment().format('YYYY-MM-DD'), siteLocation: { lat: this.target.lat, lng: this.target.lng }, rls: { cleanStaffId, isTrash } }
        })
      }
    },

    /**
     * 物件概要書
     */
    toSiteOutline() {
      const resolvedRoute = this.$router.resolve({
        name: 'SiteOutlineEdit',
        query: {
          siteCode: this.target.siteCode
        }
      })
      window.open(resolvedRoute.href, '_blank')
    }
	}
}

</script>
<style scoped>
</style>